import React from 'react';
import { observer } from 'mobx-react';
import { Selected } from 'libs/forms/styles';

export const CountrySelection = observer(({ selected, fieldStore }) => {
  const {
    optionsManager: { highlighted, showOptions },
  } = fieldStore;
  const {
    conf: { labelKey },
  } = fieldStore;
  const displayApp = showOptions ? highlighted || selected : selected;
  return <Selected>{displayApp[labelKey]}</Selected>;
});
